const getPaxForPersons = (ratePlan, persons) => {
  const { paxValues } = ratePlan
  if (!persons || !paxValues) return null
  const pax = paxValues.find(paxValue => {
    return paxValue.pax === persons
  })
  // if persons === base pax persons then we are returning rate plans total rate - base rate
  return pax || { totalRate: ratePlan.totalRate }
}

export default getPaxForPersons
